import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: '首页', path: '/' },
    { name: '选品中心', path: '/sourcing' },
    { name: '产业带联动', path: '/belt-linkage' },
    { name: '出海服务', path: '/overseas-service' },
    { name: '跨境电商', path: '/cross-border' },
    { name: '园区介绍', path: '/park-intro' },
  ];

  const isActive = (path: string) => location.pathname === path;

  const handleNavClick = (item: typeof navItems[0]) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[200] transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md h-16' : 'bg-transparent h-20'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 h-full flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
          <img
            src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/a39ee29d2ace7803e87c2156b12ede8c.png"
            alt="天健广场"
            className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-14' : 'h-20'}`}
          />
        </div>

        {/* Navigation */}
        <nav className="flex items-center gap-6">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavClick(item)}
              className={`relative text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#8B1A1A]' : 'text-white hover:text-white/80'
              } ${isActive(item.path) ? 'after:absolute after:bottom-[-8px] after:left-0 after:right-0 after:h-0.5 after:bg-[#C9A84C]' : ''}`}
            >
              {item.name}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
